<!-- src/PaymentCallback.svelte -->
<script>
    import { onMount } from 'svelte';
  
    onMount(() => {
      if (window.opener && !window.opener.closed) {
        // Reload the original tab
        try {
          window.opener.location.reload();
        } catch (e) {
          console.warn('Could not reload opener:', e);
        }
        // Close this payment tab
        window.close();
      } else {
        // Fallback: send this tab back to your invoice page
        window.location.href = '/#/invoice';
      }
    });
  </script>
  
  <main class="p-8 text-center">
    <h1 class="text-xl font-semibold">Finishing up…</h1>
    <p>Thank you! You’ll be redirected back to your app momentarily.</p>
  </main>
  